<template>
  <div v-show="isShow" class="actions-cell">
    <div class="actions-cell__btn">
      <i
        class="el-icon-check"
        style="color: green; font-size: 20px"
        @click="onClickAction(CASHIER_CONFIRM_TYPE.CONFIRM)"
      />
    </div>
    <div class="actions-cell__btn">
      <i
        class="el-icon-close"
        style="color: red; font-size: 20px"
        @click="onClickAction(CASHIER_CONFIRM_TYPE.REPORT_WRONG)"
      />
    </div>
  </div>
</template>

<script>
import { CASHIER_CONFIRM_TYPE } from '../constant'

export default {
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    CASHIER_CONFIRM_TYPE() {
      return CASHIER_CONFIRM_TYPE
    }
  },
  mounted() {
    this.isShow = this.$moment(this.params.data.date).isSame(
      this.$moment(),
      'day'
    )
  },
  methods: {
    onClickAction(actionType) {
      this.params.context.componentParent.onCashierAction(actionType)
    }
  }
}
</script>

<style lang="scss" scoped>
.actions-cell {
  display: flex;
  // justify-content: center;
  align-items: center;
  gap: 10px;
  .actions-cell__btn {
    cursor: pointer;
    height: 28px;
    width: 28px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
